define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'view/AuthenticationOptionView',
	'canvas/LoadingCanvas',
	'amdi18n-loader?!identity/nls/IdentityView_strings',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	AuthenticationOptionView,
	LoadingCanvas,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * IdentityView class
	 */
	return function (identityImageCallbacks) {
		var _identityImageCallbacks = identityImageCallbacks,
			_identityImageView = new AuthenticationOptionView(),
			_loadingCanvas = new LoadingCanvas(),
			_loadingOverlay = jQuery("<div id='skIdS_loading-shadow'></div>"),
			_buttons = null,
			_view;

		_loadingOverlay.append(_loadingCanvas.get());

		_view = (function () {
				var $view = jQuery(
					"<div id='skIdS_identity-container' class='skIdS_content-body skIdS_column-container'>" +
						"<div id='skIdS_control-column' class='skIdS_column'>" +
							"<div id='skIdS_identity-image-container'>" +
								"<div id='skIdS_identity-image-description-container'></div>" +
							"</div>" +
						"</div>" +
						"<div id='skIdS_content-column' class='skIdS_column'>" +
							"<div id='skIdS_identity-content-container'></div>" +
						"</div>" +
					"</div>");

				_identityImageView.get().attr('id', 'skIdS_identity-image');

				if (typeof _identityImageCallbacks !== 'undefined') {
					_identityImageView.get()
						.css('cursor', 'pointer')
						.on('click', function () {
							if (_buttons !== null) {
								_buttons.removeActiveStates();
								_buttons.hideButtonMenu();

								UiUtil.scrollTo(_buttons.get());
							}

							Util.callCallbacks(_identityImageCallbacks);
						});
				}

				$view.find('#skIdS_identity-image-container')
					.prepend(_identityImageView.get());

				return $view;
			}());

		window.addEventListener('resize', function () {
			if (_buttons !== null) {
				UiUtil.scrollTo(_buttons.get());
			}
		});


		// public methods

		this.get = function () {
			return _view;
		};

		/**
		 * Update view.
		 * 
		 * @param {CloudIdentity|null} identity Current CloudIdentity or null.
		 * @param {AuthenticationOption} authenticationOption AuthenticationOption of main origin of identity
		 * @returns {undefined}
		 */
		this.update = function (identity, authenticationOption) {
			var $description = _view.find('#skIdS_identity-image-description-container');
			var showFido = false;
			if (identity) {
				var binding = identity.bindingProtocol()[0]
				showFido = (binding.type() === "http://ws.skidentity.de/ci/binding/key/v1.0" && binding.origin() === "FIDO/WebAuthn")
			}

			_identityImageView.update(authenticationOption, identity !== null, showFido);

			$description.empty();

			if (identity !== null) {
				$description.append('<span>' + Strings.cloud_identity + '</span>')
						.append('<span>' + Strings.derived_from + '</span>')
						.append('<span>' + authenticationOption.description() + '</span>');
			} else {
				$description.append('<span>' + authenticationOption.description() + '</span>');
			}

			_view.find('#skIdS_identity-content-container').children().detach();

			if (identity !== null) {
				this.changeImageAppearance(identity, false);
			}
		};

		this.enableTooltip = function (message) {
			_identityImageView.enableToolTip(message);
		};

		this.disableTooltip = function () {
			_identityImageView.disableToolTip();
		};

		this.changeImageAppearance = function (identity, animate) {
			if (identity !== null && identity.isUsable()) {
				_identityImageView.enable(animate);
				_identityImageView.enableCloudID(animate);
			} else{
				_identityImageView.disable(animate);
				_identityImageView.disableCloudID(animate);
			}
		};

		this.changeButtons = function (buttons) {
			var $buttonContainer = _view.find('#skIdS_identity-button-container-container');

			_buttons = buttons;

			if ($buttonContainer.length === 0) {
				$buttonContainer = jQuery("<div id='skIdS_identity-button-container-container'></div>");

				_view.find('#skIdS_control-column').append($buttonContainer);
			}

			$buttonContainer.children().detach();
			$buttonContainer.append(buttons.get());
		};

		this.changeContent = function (content) {
			var $contentContainer = _view.find('#skIdS_identity-content-container'),
				$content = content.get();

			$contentContainer.children().detach();

			$content.on('touchstart', function () {
				if (_buttons !== null) {
					_buttons.removeActiveStates();
					_buttons.hideButtonMenu();
				}
			});

			$contentContainer
				.prepend($content)
				.find('[autofocus]')
				.focus();
		};

		this.showLoadingIndicator = function () {
			if (_view.find('#skIdS_content-column').children().first()[0] !== _loadingOverlay[0]) {
				_view.find('#skIdS_content-column').prepend(_loadingOverlay);
			}

			_loadingCanvas.enableAnimation();
		};

		this.hideLoadingIndicator = function () {
			if (_view.find('#skIdS_content-column').children().first()[0] === _loadingOverlay[0]) {
				_view.find('#skIdS_content-column').children().first().detach();
			}

			_loadingCanvas.disableAnimation();
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/identity/IdentityView.js
// module id = 166
// module chunks = 1